var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#F8F8F8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3456 10.2259H11.0472L15.4548 14.644L14.1373 15.9615L9.72088 11.5513V10.8515L9.477 10.6094C8.47231 11.47 7.17071 11.9931 5.74364 11.9931C2.57138 11.9931 0 9.42175 0 6.2495C0 3.07724 2.57138 0.505859 5.74364 0.505859C8.91589 0.505859 11.4873 3.07724 11.4873 6.2495C11.4873 7.67657 10.9633 8.97905 10.1017 9.98374L10.3456 10.2259ZM1.76728 6.2495C1.76728 8.44622 3.54693 10.2259 5.74365 10.2259C7.93948 10.2259 9.72001 8.44622 9.72001 6.2495C9.72001 4.05366 7.93948 2.27313 5.74365 2.27313C3.54693 2.27313 1.76728 4.05366 1.76728 6.2495Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.41a1175871968ccedaa722669c8f1a0f.svg";
export { ForwardRef as ReactComponent };